import { moduleFactory } from "@/factories/module";
import {
  electronBindingNavigateToExternalUrl,
  electronBindingNavigateToInternalUrl,
  electronBindingToggleMenu,
  electronBindingUpdateNow,
  electronBindingMinimizeWindow,
  electronBindingMaximizeWindow,
  electronBindingCloseWindow,
  electronBindingSetOAuthAccessToken,
  electronBindingClearOAuthAccessToken,
  electronBindingOnOAuthAccessTokenGetRequested,
  electronBindingRespondToOAuthAccessTokenGetRequest,
  electronBindingOnOAuthAccessTokenRefreshRequested,
  electronBindingOnAiToolkitRequested,
  electronBindingRespondToAiToolkitRequest,
  electronBindingRestartApp,
  electronBindingOpenSystemSoundSettings,
  electronBindingSetTheme,
  electronBindingOnBrowserMetadata,
  recallBindingPrepareDesktopRecording,
  recallBindingStartRecording,
  recallBindingPauseRecording,
  recallBindingResumeRecording,
  recallBindingStopRecording,
  recallBindingGetRecordingSession,
  recallBindingGetRecordingRecoveryState,
  recallBindingPauseRecordingSession,
  recallBindingResumeRecordingSession,
  recallBindingStopRecordingSession,
  recallBindingOnEvent,
  recallBindingGetPermissionStatus,
  recallBindingRequestPermission,
  recallBindingOnPermissionStatus,
  recallBindingOpenPermissionPane,
  recallBindingOnMeetingEvent,
  recallBindingGetSdkState,
  recallBindingOnSdkState,
  recallBindingTestUnexpectedShutdown,
  electronBindingSetCalendarEvents,
  electronBindingOnTrackedEvent,
  electronBindingSetCalendarNotificationEnabled,
  electronBindingGetCalendarNotificationEnabled,
  electronBindingSetMeetingNotificationEnabled,
  electronBindingGetMeetingNotificationEnabled,
  electronBindingSetIsClientReady,
  electronBindingSetClientMetadata,
  electronBindingClearClientMetadata,
  electronBindingGetElectronAppInfo,
  electronBindingImportAppleNotes,
  electronBindingGetAppleNoteContent,
  electronBindingCloseAppleNotesReader,
  electronBindingSetTeamsMeetingDetectionEnabled,
  electronBindingGetTeamsMeetingDetectionEnabled,
  electronBindingGetAdvancedMeetingDetectionShown,
  electronBindingSetAdvancedMeetingDetectionShown,
  electronBindingOnMenuActionEvent,
  electronBindingOnDesktopShortcutEvent,
  electronBindingResetTccAndClearCache,
  electronBindingGetAudioArtifactRef,
  electronBindingGetAudioArtifactSnapshot,
  electronBindingGetAudioArtifactUploadFailureDebugInfo,
  electronBindingFinalizeAudioArtifact,
  electronBindingRemoveAudioArtifact,
  electronBindingStartAudioUpload,
  electronBindingOnAudioUploadProgress,
  electronBindingOnAudioUploadCompleted,
  electronBindingOnAudioUploadError,
  electronBindingOnDesktopAudioWaveformUpdate,
  electronBindingAddWorkingContextSubscription,
  electronBindingGetWorkingContextSnapshot,
  electronBindingGetWorkingContextStatus,
  electronBindingOnWorkingContextMatch,
  electronBindingRemoveWorkingContextSubscription,
} from "@/modules/electron/bindings";

export const electronModule = moduleFactory.create({
  navigateToInternalUrl: electronBindingNavigateToInternalUrl,
  navigateToExternalUrl: electronBindingNavigateToExternalUrl,
  toggleMenu: electronBindingToggleMenu,
  minimizeWindow: electronBindingMinimizeWindow,
  maximizeWindow: electronBindingMaximizeWindow,
  closeWindow: electronBindingCloseWindow,
  oauthAccessToken: {
    set: electronBindingSetOAuthAccessToken,
    clear: electronBindingClearOAuthAccessToken,
    onGetRequested: electronBindingOnOAuthAccessTokenGetRequested,
    respondToGetRequest: electronBindingRespondToOAuthAccessTokenGetRequest,
    onRefreshRequested: electronBindingOnOAuthAccessTokenRefreshRequested,
  },
  aiToolkit: {
    onRequest: electronBindingOnAiToolkitRequested,
    respondToRequest: electronBindingRespondToAiToolkitRequest,
  },
  updateNow: electronBindingUpdateNow,
  restartApp: electronBindingRestartApp,
  openSystemSoundSettings: electronBindingOpenSystemSoundSettings,
  setTheme: electronBindingSetTheme,
  setCalendarNotificationEnabled: electronBindingSetCalendarNotificationEnabled,
  getCalendarNotificationEnabled: electronBindingGetCalendarNotificationEnabled,
  setMeetingNotificationEnabled: electronBindingSetMeetingNotificationEnabled,
  getMeetingNotificationEnabled: electronBindingGetMeetingNotificationEnabled,
  setTeamsMeetingDetectionEnabled: electronBindingSetTeamsMeetingDetectionEnabled,
  getTeamsMeetingDetectionEnabled: electronBindingGetTeamsMeetingDetectionEnabled,
  setAdvancedMeetingDetectionShown: electronBindingSetAdvancedMeetingDetectionShown,
  getAdvancedMeetingDetectionShown: electronBindingGetAdvancedMeetingDetectionShown,
  onBrowserMetadata: electronBindingOnBrowserMetadata,
  setCalendarEvents: electronBindingSetCalendarEvents,
  onMenuActionEvent: electronBindingOnMenuActionEvent,
  onDesktopShortcutEvent: electronBindingOnDesktopShortcutEvent,
  onTrackedEvent: electronBindingOnTrackedEvent,
  setIsClientReady: electronBindingSetIsClientReady,
  setClientMetadata: electronBindingSetClientMetadata,
  clearClientMetadata: electronBindingClearClientMetadata,
  getElectronAppInfo: electronBindingGetElectronAppInfo,
  importAppleNotes: electronBindingImportAppleNotes,
  getAppleNoteContent: electronBindingGetAppleNoteContent,
  closeAppleNotesReader: electronBindingCloseAppleNotesReader,
  resetTccAndClearCache: electronBindingResetTccAndClearCache,
  recall: {
    prepareDesktopRecording: recallBindingPrepareDesktopRecording,
    startRecording: recallBindingStartRecording,
    pause: recallBindingPauseRecording,
    resume: recallBindingResumeRecording,
    stop: recallBindingStopRecording,
    getRecordingSession: recallBindingGetRecordingSession,
    getRecordingRecoveryState: recallBindingGetRecordingRecoveryState,
    pauseRecordingSession: recallBindingPauseRecordingSession,
    resumeRecordingSession: recallBindingResumeRecordingSession,
    stopRecordingSession: recallBindingStopRecordingSession,
    onEvent: recallBindingOnEvent,
    onMeetingEvent: recallBindingOnMeetingEvent,
    getPermissionStatus: recallBindingGetPermissionStatus,
    requestPermission: recallBindingRequestPermission,
    onPermissionStatus: recallBindingOnPermissionStatus,
    openPermissionPane: recallBindingOpenPermissionPane,
    getSdkState: recallBindingGetSdkState,
    onSdkState: recallBindingOnSdkState,
    testUnexpectedShutdown: recallBindingTestUnexpectedShutdown,
  },
  audioArtifacts: {
    getAudioArtifactRef: electronBindingGetAudioArtifactRef,
    getAudioArtifactSnapshot: electronBindingGetAudioArtifactSnapshot,
    getAudioArtifactUploadFailureDebugInfo: electronBindingGetAudioArtifactUploadFailureDebugInfo,
    finalizeAudioArtifact: electronBindingFinalizeAudioArtifact,
    removeAudioArtifact: electronBindingRemoveAudioArtifact,
  },
  audioUpload: {
    startAudioUpload: electronBindingStartAudioUpload,
    onProgress: electronBindingOnAudioUploadProgress,
    onCompleted: electronBindingOnAudioUploadCompleted,
    onError: electronBindingOnAudioUploadError,
  },
  audioWaveform: {
    onUpdate: electronBindingOnDesktopAudioWaveformUpdate,
  },
  workingContext: {
    getStatus: electronBindingGetWorkingContextStatus,
    getSnapshot: electronBindingGetWorkingContextSnapshot,
    addSubscription: electronBindingAddWorkingContextSubscription,
    removeSubscription: electronBindingRemoveWorkingContextSubscription,
    onMatch: electronBindingOnWorkingContextMatch,
  },
});
